import { render, staticRenderFns } from "./notifications-table-cell-i18n.vue?vue&type=template&id=23a3eaee&"
import script from "./notifications-table-cell-i18n.vue?vue&type=script&lang=js&"
export * from "./notifications-table-cell-i18n.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports